module.exports = __webpack_public_path__ + "assets/images/oncall.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/oncall.png
// module id = 255
// module chunks = 1